const isMobile =
  window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);

document.addEventListener("DOMContentLoaded", async function () {
  await recommendedProducts()
  initSwiper();
  const productButtons = document.querySelectorAll(
    ".feature-collection-recomendation_product-button"
  );
  productButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const productId = this.dataset.productId;
      addToCart(productId);
    });
  });
});
function initSwiper() {
  const swiperContainer = document.querySelectorAll(
    "[feature-collection-recomendation]"
  );

  if (
    !swiperContainer ||
    swiperContainer == null ||
    swiperContainer.length == 0
  ) {
    return;
  }

  swiperContainer.forEach((swiper_tabs) => {
    const swipperTabs = swiper_tabs.querySelector(
      ".feature-collection-recomendation_swiper"
    );
    const swiperButtonPrev = swiper_tabs.querySelector(".swiper-button-prev");
    const swiperButtonNext = swiper_tabs.querySelector(".swiper-button-next");

    var swiper = new Swiper(swipperTabs, {
      slidesPerView: "auto",
      loop: isMobile ? true : false,
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
    });
  });
}
function addToCart(variantId) {
  let cart = isMobile
    ? document.querySelector("cart-drawer")
    : document.querySelector("cart-notification");
  if (isMobile) {
    cart.classList.remove("is-empty");
  }
  toggleSpinner(true, variantId);
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          properties: {},
        },
      ],
      sections: cart.getSectionsToRender().map((section) => section.id),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      window.upsellLogic();
      // console.log('Producto añadido:', data);
      let item = data.items[0];
      item["sections"] = data.sections;
      cart.setActiveElement(document.activeElement);
      cart.renderContents(item);

      toggleSpinner(false, variantId);
    })
    .catch((error) => {
      console.error("Error:", error);
      toggleSpinner(false, variantId);
    });
}
function toggleSpinner(show, variantId) {
  const button = document.querySelector(
    `.feature-collection-recomendation_product-button--${variantId}`
  );
  const spinner = document.querySelector(
    `.feature-collection-recomendation_product-button-spinner--${variantId}`
  );
  if (spinner) {
    if (show) {
      button.style.opacity = "0.5";
      spinner.classList.remove("hidden");
    } else {
      spinner.classList.add("hidden");
      button.style.opacity = "";
    }
  }
}

async function recommendedProducts() {
  const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;

    await fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
}
